import { PureComponent } from 'react';
import { css } from '@emotion/core';

import PropTypes from 'prop-types';
import Spinner from '../Spinner';

class LoadingOverlay extends PureComponent {
  state = { showSpinner: false, hasWaited: false };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.showSpinner !== prevState.showSpinner) {
      return {
        showSpinner: nextProps.showSpinner,
        hasWaited: false,
      };
    }
    return {};
  }

  hasWaitedTimeout = null;

  componentDidMount() {
    this.wait();
  }

  componentDidUpdate() {
    this.wait();
  }

  componentWillUnmount() {
    clearTimeout(this.hasWaitedTimeout);
  }

  wait() {
    // This component needs two render cycles to correctly initialize the
    // fade in animation. Therefore the state variable "hasWaited" is
    // switched to from false to true asynchronously whenever the "isLoading"
    // is switched from false to true
    if (!this.hasWaited) {
      clearTimeout(this.hasWaitedTimeout);

      this.hasWaitedTimeout = setTimeout(
        () => this.setState(() => ({ hasWaited: true })),
        500
      );
    }
  }

  render() {
    const { showSpinner, hasWaited } = this.state;

    if (!showSpinner) {
      return null;
    }

    return (
      <div
        css={css`
          position: absolute;
          display: flex;
          opacity: ${hasWaited ? 1 : 0};
          transition: opacity 1s ease-in;
        `}
        className="flex-column w-100 h-100 items-center justify-center bg-white-20 z-1"
      >
        <Spinner />
      </div>
    );
  }
}

LoadingOverlay.propTypes = {
  showSpinner: PropTypes.bool.isRequired, // eslint-disable-line
};

export default LoadingOverlay;
